import { gsap } from 'gsap'

function initPreviewFollower() {
    // Find every follower wrap
    const wrappers = document.querySelectorAll('[data-follower-wrap]')

    wrappers.forEach((wrap) => {
        const collection = wrap.querySelector('[data-follower-collection]')
        const items = wrap.querySelectorAll('[data-follower-item]')
        let activeFollower = null
        let xTo = null
        let yTo = null
        let lastMouse = { x: 0, y: 0 }

        const setActiveFollower = (follower) => {
            if (activeFollower === follower) return
            activeFollower = follower
            if (!activeFollower) return
            gsap.set(activeFollower, {
                xPercent: -50,
                yPercent: -50,
                x: lastMouse.x,
                y: lastMouse.y
            })
            xTo = gsap.quickTo(activeFollower, 'x', {
                duration: 0.6,
                ease: 'power3'
            })
            yTo = gsap.quickTo(activeFollower, 'y', {
                duration: 0.6,
                ease: 'power3'
            })
        }

        // Move all followers on mousemove
        window.addEventListener('mousemove', (e) => {
            lastMouse = { x: e.clientX, y: e.clientY }
            if (!activeFollower || !xTo || !yTo) return
            xTo(e.clientX)
            yTo(e.clientY)
        })

        // Enter/leave per item within this wrap
        items.forEach((item) => {
            item.addEventListener('mouseenter', () => {
                const follower = item.querySelector('[data-follower-cursor]')
                if (!follower) return
                if (activeFollower) {
                    activeFollower.classList.remove('is-active')
                }
                wrap.querySelectorAll('[data-follower-cursor]').forEach((el) => {
                    if (el !== follower) {
                        el.classList.remove('is-active')
                    }
                })
                setActiveFollower(follower)
                activeFollower.classList.add('is-active')
            })

            item.addEventListener('mouseleave', () => {
                const follower = item.querySelector('[data-follower-cursor]')
                if (!follower || activeFollower !== follower) return
                activeFollower.classList.remove('is-active')
                activeFollower = null
                xTo = null
                yTo = null
            })
        })

        // If pointer leaves the collection, clear any visuals
        collection.addEventListener('mouseleave', () => {
            if (activeFollower) {
                activeFollower.classList.remove('is-active')
            }
            activeFollower = null
            xTo = null
            yTo = null
        })
    })
}

// Initialize Image Preview Cursor Follower
document.addEventListener('DOMContentLoaded', () => {
    initPreviewFollower()
})
